import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuthStore } from '@/features/auth/store/store.ts'
import { routes } from '@/routes'

export const PrivateRoute = () => {
	const accessToken = useAuthStore((state) => state.accessToken)
	const location = useLocation()

	return accessToken ? (
		<Outlet />
	) : (
		<Navigate
			replace
			to={{
				pathname: routes.LOGIN.path,
				search:
					location.pathname !== routes.WELCOME.path
						? `redirect_to=${location.pathname}${location.search}`
						: undefined
			}}
		/>
	)
}
